import React from 'react';
import classNames from 'classnames';
import { Colors } from 'modules/theme';
import { Icon } from 'modules/ui';
import styles from './SelectArrow.module.scss';

export default function SelectArrow({
  className,
  size = 12,
  color = Colors.darkBlue,
  ...props
}) {
  const classes = classNames(styles.arrow, className);
  return (
    <Icon
      className={classes}
      name="selectArrow"
      size={size}
      color={color}
      {...props}
    />
  );
}
